import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppContextService, SettingsService } from '@core/bootstrap';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss'],
  standalone: true,
  imports: [RouterLink, NgOptimizedImage],
})
export class BrandingComponent {
  @Input() showName = true;

  readonly appContext = inject(AppContextService);

  constructor(private readonly _settings: SettingsService) {}

  get collapsed(): boolean {
    if (this._settings.options.sidenavCollapsed) {
      return true;
    }
    return false;
  }

  get wordLogo(): string {
    return this._settings.getSchemeColor() === 'dark'
      ? 'TTG-Logo-Neon.svg'
      : 'TTG-Logo-Black.svg';
  }
}
